import React, { useState } from 'react';
import Menu from './Menu';
import Categories from './Categories';
import items from './data';

function App() {
  const [menuItems, setMenuItems] = useState(items);
  const categories = ['all', ...new Set(items.map((dish) => dish.category))];
  const filterMenu = (category) => {
    if (category === 'all') {
      setMenuItems(items);
      return;
    }
    const newMenuItems = items.filter((item) => category === item.category);
    setMenuItems(newMenuItems);
  };
  return (
    <main>
      <section className='menu section'>
        <div className='title'>
          <h1>our menu</h1>
          <div className='underline'></div>
        </div>
        <Categories categories={categories} filterMenu={filterMenu} />
        <Menu menuItems={menuItems} />
      </section>
    </main>
  );
}

export default App;
